import { useQuery } from '@gogame/query';

import { loadSubscriptions } from '../source/subscriptions';
import { subscriptions } from './queryKeyFactory';

//TODO: prefetch function for data
export const useLoadSubscriptions = (options) => {
  return useQuery(
    subscriptions(),
    (_, { signal }) => loadSubscriptions({}, { signal }),
    options
  );
};
